/** Список полей рулонов TODO: поменять */
const rollsColumnDataGrid = [

  {
    dataField: 'qcId',
    caption: 'СК (рулон)',
    dataType: 'number'
  },
  {
    dataField: 'accountingDate',
    caption: 'Дата СК (рулон)',
    dataType: 'date'
  },
  {
    dataField: 'productGroupDescription',
    caption: 'Продукт',
    dataType: 'string'
  },
  {
    dataField: 'incomingDate',
    caption: 'Дата приёмки (по М-4)',
    dataType: 'date'
  },
  {
    dataField: 'batchId',
    caption: 'Партия SAP',
    dataType: 'string'
  },
  {
    dataField: 'cgId',
    caption: 'Номер партии',
    dataType: 'number'
  },
  {
    dataField: 'actualPieceId',
    caption: 'Номер УЕ',
    dataType: 'string'
  },
  {
    dataField: 'skuCoilId',
    caption: 'id SKU ПФ',
    dataType: 'string'
  },
  {
    dataField: 'psStatusName',
    caption: 'Статус УЕ',
    dataType: 'string'
  },
  {
    dataField: 'quantity',
    caption: 'Кол-во',
    dataType: 'number'
  },
  {
    dataField: 'quantityRemain',
    caption: 'Кол-во, ост.',
    dataType: 'number'
  },
  {
    dataField: 'unitShort',
    caption: 'ЕИ',
    dataType: 'string'
  },
  {
    dataField: 'weightTrim',
    caption: 'Вес обрези, т.',
    dataType: 'number'
  },
  {
    dataField: 'weightWaste',
    caption: 'Вес ДО, т.',
    dataType: 'number'
  },
  {
    dataField: 'weightEndProduct',
    caption: 'Вес ГП, т.',
    dataType: 'number'
  },
  {
    dataField: 'zdvlOrderNumId',
    caption: 'Заказ ZDVL',
    dataType: 'number'
  },
  {
    dataField: 'zdvlLineId',
    caption: 'Номер позиции заказа на переработку',
    dataType: 'number'
  },
  {
    dataField: 'thick',
    caption: 'Толщина ПФ',
    dataType: 'number'
  },
  {
    dataField: 'width',
    caption: 'Ширина ПФ',
    dataType: 'number'
  },
  {
    dataField: 'kromka',
    caption: 'Кромка',
    dataType: 'string'
  },
  {
    dataField: 'plantDescr',
    caption: 'Склад',
    dataType: 'string'
  }
];

export default rollsColumnDataGrid;
